import type { UserRegionalIdentity as GraftUserRegionalIdentity } from '@graft/nuget-gc.webportals.users'

import type { UserRegionalIdentity } from '../types/user.type'

export async function userRegionalIdentityToObject(entity: GraftUserRegionalIdentity): Promise<UserRegionalIdentity> {
  const [userRegionalIdentityId, region, userUid, lastUsedWorkspaceId] = await Promise.all([
    entity.get_userRegionalIdentityId(),
    entity.get_region(),
    entity.get_userUid(),
    entity.get_lastUsedWorkspaceId(),
  ])

  return {
    userRegionalIdentityId,
    region,
    userUid,
    lastUsedWorkspaceId,
  }
}
